import { useEffect, useRef, useState } from 'react';

const MILLISECONDS_PER_SECOND = 1000;

/** Seconds of animation played so far. It stops counting while `running` is false. */
export function useAnimationTime(running: boolean): number {
  const [time, setTime] = useState(0);
  const timeRef = useRef(0);

  useEffect(() => {
    if (!running) return undefined;
    let frame = 0;
    let last: number | null = null;
    const tick = (now: number) => {
      const elapsed = last === null ? 0 : (now - last) / MILLISECONDS_PER_SECOND;
      last = now;
      timeRef.current += elapsed;
      setTime(timeRef.current);
      frame = requestAnimationFrame(tick);
    };
    frame = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(frame);
  }, [running]);

  return time;
}
